import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-change-tab-popin',
  templateUrl: './change-tab-popin.component.html',
  styleUrls: ['./change-tab-popin.component.scss'],
  imports: [MatDialogModule, MatButtonModule, TranslateModule, MatFormFieldModule],
})
export class ChangeTabPopinComponent {}
